var initDropDown = function () {
    var elems = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(elems, {
        coverTrigger: false,
    });
};

document.addEventListener("DOMContentLoaded", initDropDown);
